/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_Content_From_This_SeInputs */

const en_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive content from this seller is now available to you.`)
};

const es_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El contenido exclusivo de este vendedor ahora está disponible para ti.`)
};

const fr_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le contenu exclusif de ce vendeur vous est désormais accessible.`)
};

const de_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusiver Inhalt von diesem Verkäufer ist jetzt für dich verfügbar.`)
};

const ja_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この出品者の限定コンテンツが利用可能になりました。`)
};

const zh_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该卖家的专属内容现已对您开放。`)
};

const ar_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحتوى الحصري من هذا البائع متاح لك الآن.`)
};

const id_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten eksklusif dari penjual ini sekarang tersedia untuk Anda.`)
};

const it_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il contenuto esclusivo di questo venditore è ora disponibile per te.`)
};

const ru_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивный контент от этого продавца теперь доступен вам.`)
};

const pt_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo exclusivo deste vendedor agora está disponível para você.`)
};

const ko_exclusive_content_from_this_se = /** @type {(inputs: Exclusive_Content_From_This_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 판매자의 독점 콘텐츠를 이제 이용할 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "Exclusive content from this seller is now available to you." |
*
* @param {Exclusive_Content_From_This_SeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_content_from_this_se = /** @type {((inputs?: Exclusive_Content_From_This_SeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_Content_From_This_SeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_content_from_this_se(inputs)
	if (locale === "es") return es_exclusive_content_from_this_se(inputs)
	if (locale === "fr") return fr_exclusive_content_from_this_se(inputs)
	if (locale === "de") return de_exclusive_content_from_this_se(inputs)
	if (locale === "ja") return ja_exclusive_content_from_this_se(inputs)
	if (locale === "zh") return zh_exclusive_content_from_this_se(inputs)
	if (locale === "ar") return ar_exclusive_content_from_this_se(inputs)
	if (locale === "id") return id_exclusive_content_from_this_se(inputs)
	if (locale === "it") return it_exclusive_content_from_this_se(inputs)
	if (locale === "ru") return ru_exclusive_content_from_this_se(inputs)
	if (locale === "pt") return pt_exclusive_content_from_this_se(inputs)
	return ko_exclusive_content_from_this_se(inputs)
});